import { cn } from "@/lib/utils";
import { Globe } from "lucide-react";
import { useState } from "react";

export const IntegrationIcon = ({
  platform,
  name,
  imageURL,
  style,
  className,
}: {
  platform?: string;
  name?: string;
  imageURL?: string;
  style?: React.CSSProperties;
  className?: string;
}) => {
  const [customImageError, setCustomImageError] = useState(false);
  const [platformIconError, setPlatformIconError] = useState(false);
  const displayName =
    name ||
    (platform && platform?.charAt(0).toUpperCase() + platform?.slice(1)) ||
    "";

  // 1. Try imageURL first if set and not errored
  if (imageURL && !customImageError) {
    return (
      <img
        style={style}
        className={cn("w-8 h-8", className)}
        src={imageURL}
        alt={displayName}
        onError={() => {
          setCustomImageError(true);
        }}
      />
    );
  }

  // 2. If imageURL is not set or errored, try platform icon (with special cases)
  if (platform === "web") {
    return <Globe style={style} className={cn("w-8 h-8", className)} />;
  }

  if (platform === "system") {
    return (
      <img
        style={style}
        className={cn("w-8 h-8", className)}
        src={`${import.meta.env.VITE_STATIC_BASE_URL || ""}/images/integrations/logos/cohesive.svg`}
        alt={displayName}
      />
    );
  }

  if (!platformIconError && platform) {
    // Normalize platform name: convert spaces and underscores to hyphens
    const normalizedPlatform = platform.toLowerCase().replace(/[\s_]/g, "-");

    return (
      <img
        style={style}
        className={cn("w-8 h-8", className)}
        src={`${import.meta.env.VITE_STATIC_BASE_URL || ""}/images/integrations/logos/${normalizedPlatform}.svg`}
        alt={displayName}
        onError={() => {
          setPlatformIconError(true);
        }}
      />
    );
  }

  // 3. If all else fails, show default icon
  return (
    <img
      style={style}
      className={cn("w-8 h-8", className)}
      src={`${import.meta.env.VITE_STATIC_BASE_URL || ""}/images/integrations/logos/default.svg`}
      alt={displayName}
    />
  );
};
